import { z } from 'zod';

export const LanguageTranslationSchema = z.object({
  defaultLang: z.string(),
});
